<template>
  <b-row class="base-row-padded">
    <b-col>
      <h2>Files</h2>
      <FilesPagination :apiUrl="'media/files'" :perPage="20"
        :queryStructure="queryStructure" @items-updated="itemsUpdated" ref="paginationComponent" />
      <b-row>
        <b-table :fields="fields" :items="filesArray" :busy="filesArray === null" @row-clicked="previewFile"
          :select-mode="'single'" :striped="false" :small="true" :hover="true" :responsive="true" :stacked="'sm'">
          <template slot="name" slot-scope="data">
            {{ data.item.name }}
          </template>

          <template #cell(count)="data">
            {{ totalPlaylistsCount(data.item) }}
          </template>

          <template #cell(id)="data" v-if="!pickerMode">
            <b-button class="m-1" variant="primary" size="sm"
              @click.prevent="showInFolder(data.item)">Open Folder</b-button>
            <b-button class="m-1" variant="danger" size="sm"
              @click.prevent="deleteFileProxy(data.item)">Delete</b-button>
          </template>
        </b-table>
      </b-row>
    </b-col>
  </b-row>
</template>
<script>
import FilesPagination from './pagination/FilesPagination.vue';
import mediaMixin from '@/views/admin/media/mediaMixin';

export default {
  components: { FilesPagination },
  mixins: [mediaMixin],
  props: {
    pickerMode: {
      type: [Boolean],
      required: false,
      default: false,
    },
    pickedItemId: {
      type: [Number],
      required: false,
      default: -1,
    },
  },
  data() {
    return {
      filesArray: null,
      queryStructure: {
        pagePropName: 'page',
        perPagePropName: 'per_page',
        searchPropName: 'name',
        responseDataKey: 'files',
        custom: {
          'with_playlist_count': 1,
        }
      },
      fields: [
        { key: 'name', label: 'Name' },
        { key: 'count', label: 'No. of Playlists', tdClass: 'td-no-wrap' },
        { key: 'id', label: 'Options', tdClass: 'td-no-wrap' },
      ],
      publishStatus: ['Unpublished', 'Published'],
    };
  },
  methods: {
    deleteFileProxy(file) {
      this.deleteFile(file).then(() => {
        this.$refs.paginationComponent.pageChanged();
      }).catch(() => {});
    },
    itemsUpdated(data) {
      this.filesArray = data;
      if (this.filesArray) {
        this.filesArray.forEach((item, idx) => {
          const plcount = this.totalPlaylistsCount(item);
          this.filesArray[idx]._rowVariant = (plcount === 0 ? 'warning' : '');
        });
      }
    },
    totalPlaylistsCount(item) {
      const count = 0 + (item.playlists_count ?? 0) + (item.loop_playlists_count ?? 0) + (item.weekly_playlists_count ?? 0);
      return count;
    },
    previewFile(file) {
      this.$root.$emit('modal-show-file-preview', {
        title: `Slide preview: ${file.name}`,
        body: '',
        file,
      })
    },
    showInFolder(file) {
      this.$router.push({name: 'media', params: {path: file.directory_id}});
    }
  },
};
</script>
